/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Discount_HintInputs */

const vi_product_lot_discount_hint = /** @type {(inputs: Product_Lot_Discount_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu tiên chọn lô này khi đơn có chiết khấu khớp`)
};

/**

* @param {Product_Lot_Discount_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_discount_hint = /** @type {((inputs?: Product_Lot_Discount_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Discount_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_discount_hint(inputs)
});